
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/password/[action]",
      function () {
        return require("private-next-pages/password/[action].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/password/[action]"])
      });
    }
  